import { AfterViewChecked, Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { Tree } from 'primeng/tree';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { QueryResultNode } from '../../ui/Node/QueryResultNode';
import { ResultList } from '../../ui/Node/ListEntity/ResultList';
import { ToolTipUtil } from '../../ui/ToolTipUtil';
import { MeddraResultList } from '../../ui/Node/MeddraNode/MeddraResultList';

@Component({
  selector: 'app-tree-view',
  styleUrl: './tree-view.component.scss',
  templateUrl: './tree-view.component.html'
})
export class TreeViewComponent implements AfterViewChecked {
  @ViewChild('tree') tree!: Tree;
  @Input() nodes: any[] = [];
  @Input() selectedNode: any;
  @Output() nodeSelect = new EventEmitter<any>();


  constructor(private injector: Injector) { }
  
  ngAfterViewChecked(): void {
    this.fixAriaHiddenIssues();
  }

  showToolTip(node: any) {
      let result = null;
      if (ToolTipUtil.displayTooltip(node)) {
        result = ToolTipUtil.showTooltip(node, this.injector);
      }
      return result;
    }


  private fixAriaHiddenIssues() {
    if (this.tree) {
      const togglerButtons = this.tree.el.nativeElement.querySelectorAll('button.p-tree-toggler');

      togglerButtons.forEach((button: HTMLElement) => {
        if (button.hasAttribute('aria-hidden')) {
          button.removeAttribute('aria-hidden'); // ✅ Fix: Remove aria-hidden
        }
      });
    }
  }

  onNodeSelect(event: any) {
    setTimeout(() => {
      this.fixAriaHiddenIssues()
      this.nodeSelect.emit(event);
    }, 10);
  }

  onNodeUnselect(event: any) {

    if (this.selectedNode === event.node) {
      setTimeout(() => {
        this.selectedNode = event.node;
      }, 0);
    }
  }

  setScrollAtSelectedElement(key: string) {
    const node = this.tree.el.nativeElement.querySelector(".p-treenode[data-id='" + key + "']");
    if (node) {
      node.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' });
    }
  }

  isValid(node: any): boolean {
    //Validation only applies to Create and Send Product Reports

    return node.data.valid || !this.injector.get(Art57Section).isCreateAndSendProductSection();
  }

  isResultNode(node:any): boolean {
    return node instanceof QueryResultNode || 
           node instanceof ResultList ||
           node instanceof MeddraResultList;
  }

  isBold(node:any) :boolean {
    return node && node.data && node.data.model && node.data.model.roleofingredient && node.data.model.roleofingredient === 1;
  }

}


